if (!window.cc_UI) {
	window.cc_UI = {};
}

(function () {
	"use strict";
	
	cc_UI.viewportMinimumWidth = (cc_Config.isStaffPortal === true ? 950 : 480);
	
	cc_UI.dialogDefaultWidth = (cc_Config.isStaffPortal === true ? 560 : 450);
	cc_UI.dialogDefaultPositionFromTop = (cc_Config.isStaffPortal === true ? 30 : 150);
	cc_UI.dialogMessageIndent = '&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&gt;&nbsp;&nbsp;&nbsp;';
	
	cc_UI.throbberWidth = 120;
	cc_UI.throbberHeight = 120;
	
	cc_UI.getDeviceFingerprint = function() {
		var clientJs = new ClientJS();
		
		var userAgent = clientJs.getUserAgent();
		// var screenPrint = clientJs.getScreenPrint();
		var pluginList = clientJs.getPlugins();
		var fontList = clientJs.getFonts();
		var localStorage = clientJs.isLocalStorage();
		var sessionStorage = clientJs.isSessionStorage();
		var timeZone = clientJs.getTimeZone();
		var language = clientJs.getLanguage();
		var systemLanguage = clientJs.getSystemLanguage();
		var cookies = clientJs.isCookie();
		var canvasPrint = clientJs.getCanvasPrint();

		return clientJs.getCustomFingerprint(userAgent, pluginList, fontList, localStorage, sessionStorage, timeZone, language, systemLanguage, cookies, canvasPrint);
	};
	
	cc_UI.autocomplete = function (selector, source, select, delay, minLength, sorted) {
		if(selector && source){
			if($.isArray(source) === true && sorted !== false){
				// sort alphabetically
				source.sort(function(a, b) {
					if (a.toLowerCase() < b.toLowerCase()){
						return -1;
					}else if (a.toLowerCase() > b.toLowerCase()){
						return 1;
					}else{
						return 0;
					}
				});
			}
			
			minLength = minLength ? minLength : 0;
					
			$.each($(selector), function(){
				var jInput = $(this); 
				var jParent = jInput.parent();
				
				if(minLength == 0){
					// insert the show all drop down button in the same position of the text box
					jParent.find('> :nth-child(' + (jInput.index() + 1) + ')').after(
						'<div class="input-group grow items-center max-w-2xl">' +
							'<div class="input-group-btn">' +
								'<button type="button" class="dropdown-toggle align-middle text-placeholder">' +
									'<i>' +
										'<svg width="25" height="25" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M9.09151 12.2473C9.50715 11.8836 10.1389 11.9258 10.5026 12.3414L15 17.4813L19.4974 12.3414C19.8611 11.9258 20.4929 11.8836 20.9085 12.2473C21.3242 12.611 21.3663 13.2428 21.0026 13.6584L16.317 19.0133C15.6198 19.8102 14.3802 19.8102 13.683 19.0133L8.99744 13.6584C8.63375 13.2428 8.67587 12.611 9.09151 12.2473Z" fill="#AAAAAA"/></svg>' +
									'</i>' +
								'</button>' +
							'</div>' +
						'</div>'
					);
					
					// detach the current text box and insert into the input group
					jParent.find(".input-group").prepend(jInput.detach());
					
					var wasOpen = false
					jParent.find('button').mousedown(function() {
						wasOpen = jInput.autocomplete("widget").is(":visible");
						
					}).click(function() {
						if(wasOpen == true) {
							jInput.autocomplete("close")
						}else{
							// show all menu items
							jInput.focus().autocomplete("search", "");
						}
					});
					
					jInput.addClass("autocompleteTextWithDropdown").addClass("pr-10");
				}
				
//				// note: don't do this because on item selection the drop down is shown with a single item...
//				// show the item menu when the text box gets focus
//				jInput.focus(function(e) {
//					if($(this).getValue().length >= minLength){
//						$(this).autocomplete("search");
//					}
//				});
			});

			var roundBorder = function() {
				// Don't round borders when there are no suggestions to display
				if (autocomplete.autocomplete("widget").children().length > 0) {
					var autocompleteIsBelow = autocomplete.offset().top - autocomplete.autocomplete("widget").offset().top < 0;
					if (autocompleteIsBelow) {
						autocomplete.css('border-bottom-left-radius', 0);
						autocomplete.css('border-bottom-right-radius', 0);
						autocomplete.css('border-bottom-width', 0);
						autocomplete.css('margin-bottom', '2px');
						autocomplete.css('border-bottom-color', '#E1E8EE');
						autocomplete.autocomplete("widget").css('border-top-left-radius', 0);
						autocomplete.autocomplete("widget").css('border-top-right-radius', 0);
						autocomplete.autocomplete("widget").css('border-top-width', 0);
						autocomplete.autocomplete("widget").offset({
							top: autocomplete.autocomplete("widget").offset().top - 2
						});
					} else {
						autocomplete.css('border-top-left-radius', 0);
						autocomplete.css('border-top-right-radius', 0);
						autocomplete.css('border-top-width', 0);
						autocomplete.css('margin-top', '2px');
						autocomplete.css('border-top-color', '#E1E8EE');
						autocomplete.autocomplete("widget").css('border-bottom-left-radius', 0);
						autocomplete.autocomplete("widget").css('border-bottom-right-radius', 0);
						autocomplete.autocomplete("widget").css('border-bottom-width', 0);
						autocomplete.autocomplete("widget").offset({
							top: autocomplete.autocomplete("widget").offset().top + 2
						});
					}
				}
			};
			var resetRoundBorder = function(autocomplete) {
				autocomplete.css('border-bottom-left-radius', '');
				autocomplete.css('border-bottom-right-radius', '');
				autocomplete.css('border-bottom-width', '');
				autocomplete.css('margin-bottom', '');
				autocomplete.css('border-bottom-color', '');
				autocomplete.autocomplete("widget").css('border-top-left-radius', '');
				autocomplete.autocomplete("widget").css('border-top-right-radius', '');
				autocomplete.autocomplete("widget").css('border-top-width', '');
				autocomplete.css('border-top-left-radius', '');
				autocomplete.css('border-top-right-radius', '');
				autocomplete.css('border-top-width', '');
				autocomplete.css('margin-top', '');
				autocomplete.css('border-top-color', '');
				autocomplete.autocomplete("widget").css('border-bottom-left-radius', '');
				autocomplete.autocomplete("widget").css('border-bottom-right-radius', '');
				autocomplete.autocomplete("widget").css('border-bottom-width', '');
			};

			var autocomplete = $(selector).autocomplete({
				appendTo: "#" + $(selector).closest(".panel-collapse.questions").attr("id"),
				source : source,
				select : select ? select : null,
				autoFocus: false,
				minLength : minLength ? minLength : 0,
				delay: delay ? delay : 0,
				position: { collision: "flip" },
				change: function(event, ui) {
					// this event listener is called when an item is selected from the dropdown menu using the mouse
					// note: if the user used the up/down keys to select an item then tabs out, this change listener is not fired but the text box change is
					//
					// when this event is fired the change event listener on the text box is not fired so lets fire it
					$(selector).trigger("change");
				},
				open: function(event, ui) {
					// fix for autocomplete requires you to click twice in iOS after update to 1.11.0
					autocomplete.autocomplete('widget').off('menufocus');
					resetRoundBorder(autocomplete);
					roundBorder(autocomplete);
				},
				close: function(event, ui) {
					resetRoundBorder(autocomplete);
					
					// RIAN: 18/05/2022
					// please note when using a mobile device the change event on the autocomplete is not triggered when calling blur()
					// i.e. '$(selector).blur()' this is because the mouse down on the device sets cancelBlue=true which suppress the changes event
					//
					// relevant code in jquery ui is below:
					//		blur: function( event ) {
					//			if ( this.cancelBlur ) {
					//				delete this.cancelBlur;
					//				return;
					//			}
					//			clearTimeout( this.searching );
					//			this.close( event );
					//			this._change( event );
					//		}
					//
					// also below is the internal jquery ui code used for inspiration
					//		change: function( event ) {
					//			if ( this.previous !== this._value() ) {
					//				this._trigger( "change", event, { item: this.selectedItem } );
					//			}
					//		}
					var autocompleteInternal = $(autocomplete).data("ui-autocomplete");
					if(autocompleteInternal.previous !== autocompleteInternal._value()){
						autocompleteInternal._trigger( "change", event, { item: null } ); // manually send a change event to allow the change handler to above to be called
					}
				},
				search: function(event, ui) {
					resetRoundBorder(autocomplete);
					roundBorder(autocomplete);
				}
			}).attr('autocomplete', false) // disable native auto complete
		}
		
		return $(selector);
	};
	
	cc_UI.unautocomplete = function (selector) {
		$(selector).autocomplete("destroy");
	};
	
	cc_UI.selectAccordionPage = function (pageId) {
		$(".collapse").each(function () {
			var isShown = $(this).hasClass("in");
			var jHeading = $(this).parent().find(".panel-heading");
			
			if ($(this).attr('id') == pageId) {
				if(isShown === false){
					$(this).collapse("show");
				} 
				jHeading.addClass("selected");
				
			}else{
				if(isShown === true){
					$(this).collapse("hide");
				}
				jHeading.removeClass("selected");
			}
		});
	};
	
	cc_UI.setVisible = function (selector, visible) {	
		visible === true ? $(selector).show() : $(selector).hide();
	}
	
	cc_UI.bindCheckboxClick = function (checkboxSelector, showOnCheckedSelector, callback) {
		// WORKAROUND: IE
		// IE does support onChange event correctly on checkboxes, it will only
		// fire change event once the widget has lost focus.
		// The workaround is to use click event and stop event propagation
		$(checkboxSelector).bind("click", function (event) {
			event.stopPropagation();
			$(showOnCheckedSelector).toggle();
			if(callback){
				callback();
			}
		});
	};
	
	cc_UI.toggleDisabled = function (selector) {
		$(selector).prop('disabled', function(i, v) { return !v; });
	};
	
	cc_UI.showProgressDialog = function () {
		var jProgressDialog = $('#progressDialog');
		
		if (jProgressDialog.length == 0) {			
			$('body').append('' +
				'<div id="progressDialog">' +
					'<svg viewBox="-700 -700 1400 1400" style="--d0: 942px; --d1: 2826px">' +
						'<linearGradient id="g">' +
							'<stop stop-color="#18B4E9"></stop>' +
							'<stop stop-color="#3482C8" offset="1"></stop>' +
						'</linearGradient>' +
						'<mask id="m">' +
							'<circle r="1200" fill="#000"></circle>' +
							'<use xlink:href="#c"></use>' +
						'</mask>' +
						'<circle id="c" r="600"></circle>' +
						'<g>' +
							'<use xlink:href="#c"></use>' +
						'</g>' +
					'</svg>' +
				'</div>');
			
			jProgressDialog = $('#progressDialog');
			jProgressDialog.dialog({ 
				buttons: {},
				closeOnEscape: false,
				modal: true,
				draggable: false,
				resizable: false,
				autoOpen: false,
				position: {my: "top", at: "top+35%"},
				close: function (event, ui) {
					jProgressDialog.dialog("destroy").remove();
				},
				open: function (event, ui) { 
					var parent = jProgressDialog.parent();
					
					parent.css('max-height', cc_UI.throbberHeight + 'px').css('background-color', 'transparent');
						
					parent.find('.ui-dialog-titlebar-close').hide();
					parent.find('.ui-dialog-titlebar').hide();
					parent.find('.ui-dialog-content')
						.css('min-height', cc_UI.throbberHeight + 'px').css('max-height', cc_UI.throbberHeight + 'px')
						.css('min-width', cc_UI.throbberWidth +'px').css('max-width', cc_UI.throbberWidth +'px')
						.css('overflow', 'hidden')
						.css('padding', '7px 7px');
				},
				height: cc_UI.throbberHeight,
				minHeight: cc_UI.throbberHeight,
				width: cc_UI.throbberWidth,
				minWidth: cc_UI.throbberWidth
			});
		}
		
		jProgressDialog.dialog('open');
	};
	
	cc_UI.hideProgressDialog = function () {
		cc_UI.hideDialog('progressDialog');
	};
	
	cc_UI.hideDialog = function (dialogId) {
		var jDialog = $('#' + dialogId);
		
		if(jDialog.length > 0){
			jDialog.dialog('close');
		}
	};
	
	cc_UI.createSimpleDialog = function (dialog, item) {
		var defaults = {
			backgroundColor : '#FFFFFF',
			cancelText : 'Cancel',
			closeOnEscape: true,
			closable: true, 
			enforceMaximumHeight : true,
			modal: true,
			okText : 'Ok',
			positionFromTop : cc_UI.dialogDefaultPositionFromTop,
			showButtons : true,
			supportsErrors: true,
			supportsWarnings: true,
			width : cc_UI.dialogDefaultWidth,
			maxWidth: 'none'
		};
		
		$.extend(defaults, dialog);

		// remove this dialog if it exists
		cc_UI.hideDialog(defaults.id);
		
		// setup buttons
		var buttons = {};
		
		// cancel button
		var cancel = function () { 
			$('#' + defaults.id).dialog("close");
		};
		
		if(typeof defaults.cancel !== "function") {
			defaults.cancel = cancel;
		}
		
		if(defaults.closable == true){
			buttons[defaults.cancelText] = defaults.cancel;
		}
		
		// additional buttons
		if(defaults.additionalButtons){
			for(var i = 0; i < defaults.additionalButtons.length; i++){
				var additionalButton = defaults.additionalButtons[i];
				
				buttons[additionalButton.text] = function () { 
					additionalButton.action.call(this);
				};
			}
		}
		
		// ok button
		buttons[defaults.okText] = function () { 
			if (defaults.ok) {
				defaults.ok.call(this);
			}else{
				defaults.cancel.call(this); // just cancel if there is no ok action
			}
		};
		
		var html = 	'<div id="' + defaults.id + '" title="' + defaults.title + '">';
		
		// setup error support
		if(defaults.supportsErrors == true){
			html +=		'<table class="dialogErrorContainer" style="display:none;"></table>';		 
		}
		
		// setup warning support
		if(defaults.supportsWarnings == true){
			html +=		'<table class="dialogWarningContainer" style="display:none;"></table>';		 
		}
		
		html +=	defaults.content + '</div>';
		
		var position = (typeof defaults.positionFromTop !== 'undefined' ? 
				{ my: "top", at: "top+" + defaults.positionFromTop} : 
				{ my: "top", at: "top+150" });
		
		$('body').append(html);
		var options = {
			autoOpen: false, 
			buttons: buttons,
			closeOnEscape: defaults.closeOnEscape, 
			draggable: false,
			modal: defaults.modal, 
			position: position,
			resizable: false, 
			width: defaults.width,
			close: function (event, ui) {
				if (defaults.close) {
					defaults.close.call(this);
				}
				
				if(defaults.enforceMaximumHeight === true){
					$('#' + defaults.id).parent().unbind('resize');
				}
				
				$('#' + defaults.id).dialog("destroy").remove();

				if ($("html").attr("dialog-depth") && parseInt($("html").attr("dialog-depth")) > 1) {
					$("html").attr("dialog-depth", parseInt($("html").attr("dialog-depth")) - 1);
				} else {
					$("html").css("overflow" , "");
					$("html").removeAttr("dialog-depth");
				}
			},
			open : function () {
				var jDialog = $('#' + defaults.id);
				var parent = jDialog.parent();
				
				cc_UI.applyDialogStyling(defaults.id, defaults.cancelText);
				
				if(defaults.closable == false) {
					parent.find('.ui-dialog-titlebar-close').hide();
				}
				if(defaults.showButtons == false) {
					parent.find('.ui-dialog-buttonpane').hide();
				}else{
					parent.find('.ui-dialog-buttonpane :button').blur();
				}
				if(defaults.parentPosition) {
					parent.css('position', defaults.parentPosition);
				}
				
				if (defaults.open) {
					defaults.open.call(this);
				}
				
				if(defaults.showButtons == true) {
					// override default behaviour and dont auto focus on first button
					parent.find('.ui-dialog-buttonpane :button').blur();
				}
				
				if(defaults.minHeight) {
					jDialog.css('min-height', defaults.minHeight);
				}
				
				if(defaults.maxHeight) {
					jDialog.css('max-height', defaults.maxHeight);
				}
				
				// ensure up/down arrows work correctly for dialogs with scrollable bodies
				jDialog.attr("tabindex", "-1").css("outline", "none").focus();

				// For nesting dialogs, we need to keep track of how many are stacked so that we can remove the overflow blocking at the right time
				if ($("html").attr("dialog-depth")) {
					$("html").attr("dialog-depth", parseInt($("html").attr("dialog-depth")) + 1);
				} else {
					$("html").attr("dialog-depth", 1);
					$("html").css("overflow" , "hidden");
				}
			}
		};
		
		$.extend(options, defaults.customAttributes);
		
		if (defaults.beforeClose) {
			options.beforeClose = defaults.beforeClose;
		}
		$('#' + defaults.id).dialog(options);
		$('#' + defaults.id).parent().css('maxWidth', defaults.maxWidth);
		
		if (defaults.init) {
			defaults.init.call();
		}
		
		$('#' + defaults.id).dialog('open').hide();
		
		if(defaults.enforceMaximumHeight === true){
			cc_UI.enforceMaximumDialogHeight(defaults.id, defaults.contentId, defaults.positionFromTop);
		};
		
		$('#' + defaults.id).show();
		
		if (defaults.firstOpen) {
			defaults.firstOpen.call(item);
		}
		
		return $('#' + defaults.id);
	};
	
	cc_UI.applyDialogStyling = function (dialogId, cancelText) {
		var jDialog = $('#' + dialogId);
		var parent = jDialog.parent();
		
		parent.css('box-shadow', '0 5px 15px rgba(0, 0, 0, 0.5)');

		parent.find('.ui-dialog-buttonpane :button').addClass('btn');
		parent.find('.ui-dialog-buttonpane :button:contains(' + cancelText + ')').addClass('btn-default');
		parent.find('.ui-dialog-buttonpane :button:not(:contains(' + cancelText + '))').addClass('btn-primary');

		// ensure the close X button is styled correctly
		parent.find('.ui-dialog-titlebar-close')
			.addClass('ui-button ui-corner-all ui-widget ui-button-icon-only')
			.append(
				'<span class="ui-button-icon ui-icon ui-icon-closethick"></span>' +
				'<span class="ui-button-icon-space"></span>'
			);
	};
	
	cc_UI.isStandardInfomationDialogShown = function () {
		return 	$('#showErrorDialog').length != 0 || 
				$('#showWarningDialog').length != 0 || 
				$('#showNotificationDialog').length != 0 ||
				$('#showConfirmDialog').length != 0
	};
	
	cc_UI.showErrorDialog = function (error, dialogTitle, width, className) {
		var dialog = {
			id : "showErrorDialog",
			title : dialogTitle || 'Error',
			content : '',
			width: width || (cc_UI.isMobileDevice() == true ? 450 : 550), 
			closable: false,
			firstOpen : function(){
				if(error){
					cc_UI.attachErrorToDialog('showErrorDialog', error, className);
				}
			}
		};
		
		cc_UI.createSimpleDialog(dialog);
	};
	
	cc_UI.showWarningDialog = function (warning, dialogTitle, width) {
		var dialog = {
			id : "showWarningDialog",
			title : dialogTitle || 'Warning',
			content : '',
			width: width || (cc_UI.isMobileDevice() == true ? 450 : 550), 
			closable: false,
			firstOpen : function(){
				if(warning){
					cc_UI.attachWarningToDialog('showWarningDialog', warning);
				}
			}
		};
		
		cc_UI.createSimpleDialog(dialog);
	};
	
	cc_UI.showNotificationDialog = function (message, title, ok, width, warningMessage) {
		var dialog = {
			id : 'showNotificationDialog',
			title : title,
			ok : ok,
			content : message ? '<p id="notificationDialogMessage">' + message + '</p>' : '',
			width: width || (cc_UI.isMobileDevice() == true ? 450 : 550), 
			closable: false,
			firstOpen : function(){
				if(warningMessage){
					cc_UI.attachWarningToDialog('showNotificationDialog', warningMessage);
				}
			}
		};
		
		cc_UI.createSimpleDialog(dialog);
	};
	
	cc_UI.showConfirmDialog = function (message, ok, cancel, title) {
		var dialogId = 'showConfirmDialog';
		var title = title || 'Confirm';
		
		$('body').append('<div id="' + dialogId + '" title="' + title + '"><p id="confirmDialogMessage"></p></div>');
		$('#' + dialogId + '').dialog({
			closeOnEscape: true, 
			modal: true, 
			draggable: false, 
			resizable: false, 
			autoOpen: false,
			position: { my: "top", at: "top+150" },
			close: function (event, ui) {
				if (cancel) {
					cancel.call();
				}
				$('#' + dialogId + '').dialog("destroy").remove();

				if ($("html").attr("dialog-depth") && parseInt($("html").attr("dialog-depth")) > 1) {
					$("html").attr("dialog-depth", parseInt($("html").attr("dialog-depth")) - 1);
				} else {
					$("html").css("overflow" , "");
					$("html").removeAttr("dialog-depth");
				}
			},
			buttons: { 
				"No": function () { 
					$(this).dialog("close"); 
				},
				"Yes": function () { 
					if (ok) {
						ok.call();
					}
					$(this).dialog("close"); 
				}
			},
			open : function () {
				$('#' + dialogId + ' p').html(message);
				
				cc_UI.applyDialogStyling(dialogId, "No");
				
				$('#' + dialogId + '').parent().find('.ui-dialog-buttonpane :button').blur();
				$(this).css('min-height','');

				// For nesting dialogs, we need to keep track of how many are stacked so that we can remove the overflow blocking at the right time
				if ($("html").attr("dialog-depth")) {
					$("html").attr("dialog-depth", parseInt($("html").attr("dialog-depth")) + 1);
				} else {
					$("html").attr("dialog-depth", 1);
					$("html").css("overflow" , "hidden");
				}
			}
		}).dialog('open');
	};
	
	cc_UI.attachErrorsToDialog = function (dialogId, errors) {
		var errorsHtml = '<tr><td><a id="dialogErrorMessage"><span class="dialogErrorTitle">The following errors exist</span></td></tr>';
		cc_Util.invokeOnElements(errors, function () {
			errorsHtml += '<tr><td><span class="dialogErrorMessage">&gt; ' + this.description + '</span></td></tr>';
		});
		
		var jDialogMessageContainer = $('#' + dialogId + " .dialogErrorContainer");
		
		// scroll to the message, to draw attention to it
		cc_UI.attachAndScrollToDialogMessage(jDialogMessageContainer, errorsHtml);
	};	
	
	cc_UI.attachErrorToDialog = function (dialogId, title, className) {
		var errorsHtml = '' +
			'<tr>' +
				'<td>' +
					'<span class="dialogErrorTitle' + (className ? ' ' + className : '') + '">' + title + '</span>' +
				'</td>' +
			'</tr>';
		var jDialogMessageContainer = $('#' + dialogId + " .dialogErrorContainer");
		
		// scroll to the message, to draw attention to it
		cc_UI.attachAndScrollToDialogMessage(jDialogMessageContainer, errorsHtml);
	};	
	
	cc_UI.attachWarningToDialog = function (dialogId, title) {
		var errorsHtml = '<tr><td><span class="dialogWarningTitle">' + title + '</span></td></tr>';
		var jDialogMessageContainer = $('#' + dialogId + " .dialogWarningContainer");
		
		// scroll to the message, to draw attention to it
		cc_UI.attachAndScrollToDialogMessage(jDialogMessageContainer, errorsHtml);
	};	
	
	cc_UI.attachAndScrollToDialogMessage = function (jDialogMessageContainer, messageHtml) {
		
		// we need to add the border style manually. if we add the border style directly
		// on the css class then it is always visible even of the dialogMessageContainer is hidden
		jDialogMessageContainer.empty().prepend(messageHtml).show();
		
		// scroll to the message, to draw attention to it
		jDialogMessageContainer.parent().scrollTop(0);
	};

	cc_UI.clearErrors = function (dialogId) {
		// clear existing errors
		$('#' + dialogId + " .dialogErrorContainer").hide().empty().css("border-style", "");
	};
	
	// TODO cc_Renderer.getCurrentFocusedQuestion() and cc_UI.getFocusedQuestionId() should be merged
	cc_UI.getFocusedQuestionId = function () {
		var question = null;
		var focused = cc_Util.getFocused();
		
		if(focused && focused.length > 0 && $(focused).attr('cc-field')){
			question = cc_Model.anyLevelQuestionMap[$(focused).attr('cc-field')];
		}
		
		return question ? question.id : null;
	};
	
	cc_UI.calculateMaximumDialogWidth = function () {
		return $(window).width() * .9; // 90% to leave gaps on the side
	};
	
	cc_UI.enforceMaximumDialogHeight = function (dialogId, contentId, positionFromTop) {
		if(cc_UI.isMobileDevice() == false){
			$('#' + dialogId).parent().bind('resize', function() {
				// attach to resize event as webkit only actually renders the populates item
				// once the open dialog event is complete. the resize event will fire once rendering is complete
				var contentViewport = contentId ? contentId : dialogId;
				var contentViewportHeight = $('#' + contentViewport).height();
				var contentViewportPreferedHeight = contentViewportHeight - cc_Util.calculateDialogHeightOverflow(dialogId, positionFromTop);
				
				// We must Math.floor the heights due to floating point inaccuracies when retrieving the heights
				// This will prevent top offset overcompensation on the browser where the top of the modal is above the screen
				if(Math.floor(contentViewportHeight) > Math.floor(contentViewportPreferedHeight)){
					// remove the padding from the top of the screen. not doing this means the
					// first click on the close button on the top right of the dialog will be ignored if
					// the user has performed a mouse scroll once the dialog has been resized
					$('#' + dialogId).dialog('option', 'position', {my: 'center', at: '0'});
	
					$('#' + contentViewport).height(contentViewportPreferedHeight).css('overflow', 'auto');
					
					$.doTimeout(100, function(){
						var dialog = $('#' + dialogId).parent();
						
						if(dialog && dialog.offset()){
							// need to handle when cc_OperatorPortalAPI is not present in the browser
							if(typeof cc_OperatorPortalAPI !== 'undefined' && cc_OperatorPortalAPI._renderer.isFormShown() === true && dialogId != cc_OperatorPortalAPI._dialogs.interview.id()){
								dialog.css('top', (dialog.position().top - positionFromTop) + "px"); // animate is inconsistant when a dialog is shown on top of the interview dialog
								
							}else{
								$('html,body').animate({scrollTop: dialog.offset().top}, 'fast');
							}
						}
						
						return false; // poll
					});
				}
			});
		}
	};
	
	cc_UI.flash = function(elements, count, duration) {
		for(var i = 0; i < count; i++){
			if(elements.is(':visible')) {
				elements.fadeOut(duration);
			}
			elements.fadeIn(duration);
		}
	};
	
	cc_UI.clickOrEnter = function(elements, callback) {
		$.each(elements, function(){
			var jthis = $(this);
			
			if(jthis.is(":button") == true){
				jthis.bind('click', function(event) {
					callback();
				});
			}else{
				jthis.bind('keyup', function(event) {
					var code=event.charCode || event.keyCode;
					if(code && code == 13) {// enter pressed
						callback();
					};
				});
			}
			
		});
	};
	
	cc_UI.moveToPageAnchor = function (anchor, callback) {
		$('html,body').animate({
			 scrollTop: $('[href="#' + anchor + '"]').offset().top
		},
		{
			complete: function() {
				if (callback) {
					callback.call();
				}
			}
		}
		);
	};
	
	cc_UI.moveToPageElement = function (element, duration, topPadding) {
		var elementTop = $(element).offset().top;
		
		if(topPadding && topPadding < elementTop){
			elementTop -= topPadding; 
		}
		
		$('html,body').animate({
			 scrollTop: elementTop,
			 duration: duration ? duration : 400,
		});
	};
	
	cc_UI.truncateWithEllipsis = function (jElements, definedMaxWidth, fontFamilyAndSize) {
		var ellipsis = '...';
		
		$.each(jElements, function() {
			var text = $(this).html();
			
			var attached = $('<div>' + text + '</div>').css({
				'position': 'absolute', 
				'float': 'left', 
				'white-space': 'nowrap', 
				'visibility': 'hidden', 
				'font': fontFamilyAndSize ? fontFamilyAndSize : '14px \'Open Sans\''
			}).appendTo($('body'));
			
			var actualWidth = attached.width();
			var maxWidth = (definedMaxWidth != null && definedMaxWidth > 0 ? definedMaxWidth : $(this).width());
			
			attached.remove();
			
			if(actualWidth > maxWidth){
				var updatedTextLength = Math.floor(text.length * (maxWidth / actualWidth));
				
				// factor in the width of the ellipsis
				if(text.length - updatedTextLength <= ellipsis.length){
					updatedTextLength = updatedTextLength - ellipsis.length;
				}else{
					updatedTextLength = updatedTextLength - 1;
				}
				
				var truncated = text.substring(0, updatedTextLength);
				
				if(truncated){
					$(this).html(truncated + '<span>' + ellipsis + '</span>')
						.attr('data-toggle', 'tooltip')
						.attr('title', text)
						.attr('data-container', 'body')
						.tooltip();
				}
			}
		});
	};
	
	cc_UI.getCurrentPage = function(){
		return window.location.pathname.split("/").pop();
	};
	
	cc_UI.hasVisibleDialog = function(){
		// ignore throbber if shown
		return $(".ui-dialog:visible").filter(function(){
					return $(this).find("#progressDialog").length == 0;
				}).length > 0;
	};
	
	cc_UI.isMobileDevice = function(){
		// userAgentData API is not yet widely supported, have a fallback implementation available
		var userAgentDataIsMobile = window.navigator.userAgentData && window.navigator.userAgentData.mobile;
		var isMobileDevice = typeof userAgentDataIsMobile === 'boolean'
			? userAgentDataIsMobile
			: (/android|webos|iphone|ipad|ipod|blackberry|iemobile|opera mini/i.test(navigator.userAgent.toLowerCase()))
		return isMobileDevice;
	};
	
	cc_UI.initViewpoint = function(){
		try{
			var width = screen.width;
			var minWidth = cc_UI.viewportMinimumWidth;
			
			if (width <= minWidth) {
				// enforce a minimum width so that we have a floor to work with from a UX perspective
				$("[name=viewport]").attr("content", "width=" + minWidth + ",user-scalable=no,user-scalable=0");
			}else {
				// otherwise use the width of the device
				$("[name=viewport]").attr("content", "width=device-width,user-scalable=no,user-scalable=0");
			}
		}catch(error){}
	};

	cc_UI.calculate1vh = function() {
		// First we get the viewport height and we multiple it by 1% to get a value for a vh unit
		let vh = window.innerHeight * 0.01;
		// Then we set the value in the --vh custom property to the root of the document
		document.documentElement.style.setProperty('--vh', `${vh}px`);
	}

	cc_UI.currentlySelectedPage = function() {
		return $(".page_navigator_item.selected");
	}

	cc_UI.pageSelectedWithinPageGroup = function(pageGroupId, pageNavigator) {
		var pageGroupDOM = pageNavigator.find(cc_Renderer.getPageNavigatorItemSelectorByGroup(pageGroupId));
		return $(pageGroupDOM).filter(".selected").length !== 0;
	}
	cc_UI.pageGroupHasErrors = function(pageGroupId, pageNavigator) {
		var pageGroupDOM = pageNavigator.find(cc_Renderer.getPageNavigatorItemSelectorByGroup(pageGroupId));
		return $(pageGroupDOM).find("i.errorIcon").length !== 0;
	}
	cc_UI.pageGroupHasWarnings = function(pageGroupId, pageNavigator) {
		var pageGroupDOM = pageNavigator.find(cc_Renderer.getPageNavigatorItemSelectorByGroup(pageGroupId));
		return $(pageGroupDOM).find("i.warningIcon").length !== 0;
	}
	cc_UI.pageGroupIsCompleted = function(pageGroupId, pageNavigator) {
		var pageGroupDOM = pageNavigator.find(cc_Renderer.getPageNavigatorItemSelectorByGroup(pageGroupId));
		return $(pageGroupDOM).find("i.completedIcon").length === $(pageGroupDOM).length;
	}

	cc_UI.attachCollapsible = function(collapsibleSelector, toggleOpen, toggleClose, toggleText) {

		/**
		 * Collapsible assumes the following HTML structure
		 *
		 * 	<div class="collapse">
		 * 		<div class="collapseToggle"></div>
		 * 		<div class="collapsible [collapsed|uncollapsed]"></div>
		 * 	</div>
		 */

		$(collapsibleSelector)
			// $(this).find(".collapsed").first().closest(".collapse").is($(this))
			// This makes sure that we are targeting the correct collapsible node for nested collapsibles
			.each(function() {
				if ($(this).find(".collapsible.collapsed").first().length > 0 && $(this).find(".collapsible.collapsed").first().closest(".collapse").is($(this))) {
					if (toggleText) {
						// If there is toggleText, then we want to add a wrapper div around collapseToggle to house the toggleText
						$(this).find(".collapseToggle").first().wrap("<div class='collapseToggleContainer flex items-center gap-1 text-sm'>")
						$(this).find(".collapseToggleContainer").prepend("<span>" + toggleText + "</span>");
					}
					$(this).find(".collapseToggle").first().append(toggleOpen);
				}
				if ($(this).find(".collapsible.uncollapsed").first().length > 0 && $(this).find(".collapsible.uncollapsed").first().closest(".collapse").is($(this))) {
					if (toggleText) {
						// If there is toggleText, then we want to add a wrapper div around collapseToggle to house the toggleText
						$(this).find(".collapseToggle").first().wrap("<div class='collapseToggleContainer flex items-center gap-1 text-sm'>")
						$(this).find(".collapseToggleContainer").prepend("<span>" + toggleText + "</span>");
					}
					$(this).find(".collapseToggle").first().append(toggleClose);
				}
			});

		// This will emulate hiding the collapsible upon the first attach
		$(collapsibleSelector).find(".collapsible.collapsed").css({height:0});
		$(collapsibleSelector).find(".collapseToggle").addClass("cursor-pointer");
		$(collapsibleSelector).find(".collapseToggle").click(function(event) {
			var collapse = $(event.currentTarget).closest(".collapse");
			var collapseToggle = collapse.find(".collapseToggle").first();

			var collapsible = collapse.find(".collapsible").first();
			var collapsed = collapsible.hasClass("collapsed");
			var uncollapsed = collapsible.hasClass("uncollapsed");

			var collapsibleAncestors = collapsible.parents(".collapsible")

			if (collapsed) {
				collapseToggle.empty().append(toggleClose);
				collapsible.removeClass("collapsed").addClass("uncollapsed");
				collapsible.animate({height: collapsible[0].scrollHeight}, 250);
				// Because the height transition only applies to the current collapsible, if there are nested collapsibles, then we need to apply the same amount of height change to the ancestors too
				collapsibleAncestors.each(function() {
					$(this).animate({height:this.scrollHeight + collapsible[0].scrollHeight}, 250);
				})
			} else if (uncollapsed) {
				collapseToggle.empty().append(toggleOpen);
				collapsible.removeClass("uncollapsed").addClass("collapsed");
				collapsible.animate({height: 0}, 250);
				// Because the height transition only applies to the current collapsible, if there are nested collapsibles, then we need to apply the same amount of height change to the ancestors too
				collapsibleAncestors.each(function() {
					$(this).animate({height:this.scrollHeight - collapsible[0].scrollHeight}, 250);
				})
			}
		});
	}

	cc_UI.attachToggleOptions = function(toggleSelector, multiselect, callback) {

		/**
		 * ToggleOptions assumes the following HTML structure
		 *
		 * 	<div class="toggleOptions">
		 * 	    <label class="toggleOption selected"><input type="checkbox" ...></input></label>
		 * 	    <label class="toggleOption"><input type="checkbox" ...></input></label>
		 * 	</div>
		 */

		function multiSelectHandler(event) {
			/**
			 * Multiselect supports a "ALL" toggle which when clicked will represent having all toggles being selected, this is alternative behaviour to allow a "select all" style toggle
			 */
			var clickedToggle = $(event.currentTarget).closest(".toggleOption");
			var allToggles = $(event.currentTarget).closest(".toggleOptions").children(".toggleOption").has("input:not([value=ALL])")
			var theAllToggle = $(event.currentTarget).closest(".toggleOptions").children(".toggleOption").has("input[value=ALL]")

			if(theAllToggle.length > 0) {
				if (clickedToggle.find('input').val() === "ALL") {
					theAllToggle.addClass("selected");
					theAllToggle.find('input').prop('checked', true);
					allToggles.removeClass("selected");
					allToggles.find('input').prop('checked', false);
				} else {
					clickedToggle.toggleClass("selected");
					clickedToggle.find('input').click();
					theAllToggle.removeClass("selected");
					theAllToggle.find('input').prop('checked', false);
					if (allToggles.children("input:checked").length === 0 || allToggles.children("input:checked").length === allToggles.length) {
						// This means all the explicit toggles have been set, change it to the 'ALL' toggle
						theAllToggle.addClass("selected");
						theAllToggle.find('input').prop('checked', true);
						allToggles.removeClass("selected");
						allToggles.find('input').prop('checked', false);
					}
				}
			} else {
				clickedToggle.toggleClass("selected");
				clickedToggle.find('input').click();
			}
		}

		function singleSelectHandler(event) {
			var toggle = $(event.currentTarget).closest(".toggleOption");
			var allToggles = $(event.currentTarget).closest(".toggleOptions").children(".toggleOption");
			allToggles.removeClass("selected");
			toggle.addClass("selected");
		}

		var toggleHandler = multiselect ? multiSelectHandler : singleSelectHandler;

		$(toggleSelector).change(function(event) {
			toggleHandler(event);
			if (callback) {
				callback(event)
			}
		})
	}

	cc_UI.attachMirrorFrameInsertScriptOptions = function(codeMirrorDOM, mirrorFrame) {
		codeMirrorDOM.parent().find("#insertScriptOptions button").on("focus", function() {
			$(this).parent().find("ul").css('display', 'block')
		})

		codeMirrorDOM.parent().find("#insertScriptOptions button").on("blur", function(event) {
			/**
			 * The blur event fires before the onClick of a dropdown item, this prevents the onClick from firing correctly
			 * This is solved by preventing the hiding of the dropdown menu when we know that a dropdown item has been clicked
			 * We can determine this by checking event.relatedTarget, as this is the DOM element of where you clicked to make the dropdown lose focus
			 * tabIndex="-1" is needed to ensure that the dropdown item appears in event.relatedTarget
			 *
			 * https://stackoverflow.com/a/57983847
			 */

			var dropdownList = $(this).parent().find("ul")
			if (!dropdownList.has(event.relatedTarget).length > 0) {
				dropdownList.css('display', 'none')
			}
		})

		codeMirrorDOM.parent().find("#insertScriptOptions ul").hide();

		$.each(codeMirrorDOM.parent().find('#insertScriptOptions li'), function() {
			$(this).click(function () {
				codeMirrorDOM.parent().find("#insertScriptOptions ul").hide();
				mirrorFrame[$(this).find("a").attr('id')].call(mirrorFrame);
			});
		});
	}
	
	//
	// GLOBAL UI SETUP
	//
	cc_UI.initialise = function() {
		cc_UI.initViewpoint();
		window.addEventListener('resize', function(event) {
			cc_UI.initViewpoint();
		});

		// suppress browser back functionality when backspace is pressed
		if(!cc_UI.isMobileDevice()){
			$(document).on("keydown", function (e) {
				if (e.which === 8) {
					if($(e.target).is("input[type=text], input[type=number], input[type=password], input[type=file], textarea")) {
						// allow backspace execution on text editor
					}else{
						e.preventDefault();
					}
				}
			});
		}

		// Recalculate what 1vh is for due to mobile browsers not accounting for address bar and navigation bar
		cc_UI.calculate1vh();
		window.addEventListener('resize', function() {
			cc_UI.calculate1vh();
		});
	}
	cc_UI.initialise();
	
	$(document).ready(function () {
		// table sorter for dates where the cell labels are not sortable, for example: 2 Days Ago and 1 Month Ago
		$.tablesorter.addParser({
			id: 'custom-milliseconds',
			is: function(s, table, cell, $cell) {
				return false;
			},
			format: function(s, table, cell, cellIndex) {
				return $(cell).attr('data-milliseconds') || s;
			},
			parsed: false,
			type: 'numeric'
		});
	});

	// for cases where IE does not include milliseconds in the serialized version 
	// but firefox does, effects the scheduled operation
	//
	// make dates format to ISO8601
	Date.prototype.toJSON = function (key) {
		function f(n) {
			// Format integers to have at least two digits.
			return n < 10 ? '0' + n : n;
		}

		return this.getUTCFullYear()   + '-' +
			 f(this.getUTCMonth() + 1) + '-' +
			 f(this.getUTCDate())	  + 'T' +
			 f(this.getUTCHours())	 + ':' +
			 f(this.getUTCMinutes())   + ':' +
			 f(this.getUTCSeconds())   + '.' +
			 f(this.getUTCMilliseconds())   + 'Z';
	};
	
	// dispay alert as handler of last resort for any js errors
	window.onerror = function(msg, url, line, col, error) {
		// note that col & error are new to the HTML 5 spec and may not be supported in every browser.  It worked for me in Chrome.
		var extra = !col ? '' : '\ncolumn: ' + col;
		extra += !error ? '' : '\nerror: ' + error;

		// you can view the information in an alert to see things working like this:
		alert("Error: " + msg + "\nurl: " + url + "\nline: " + line + extra);

		return false;
	};
}());